/**
 * Shared TanStack Query key factory for notifications.
 *
 * Extracted so non-component callers (push notification click handling,
 * plugins) can invalidate the same caches the drawer queries populate.
 */
export const notificationQueryKeys = {
  all: () => ['notifications'] as const,
  infinite: {
    all: () => ['notifications', 'infinite', 'all'] as const,
    unread: () => ['notifications', 'infinite', 'unread'] as const,
  },
}
